/* eslint-disable react-hooks/exhaustive-deps */
import { KTSVG } from '../../_metronic/helpers'
import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap-v5'
import Swal from 'sweetalert2'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Select from 'react-select'
import { Link, useHistory } from 'react-router-dom'

interface SelectOption {
	label: string;
	value: number | string;
	itemCode?: string;
	unitName?: string;
}

interface OpeningRow {
	idItems: number | '';
	itemName: string;
	unitName: string;
	productionQuantity: number | '';
	ratePerUnit: number | '';
	batchNo: string;
	weightInKg: number | '';
}

const BLENDING_PROJECT_ID = 1

const emptyRow = (): OpeningRow => ({
	idItems: '',
	itemName: '',
	unitName: '',
	productionQuantity: '',
	ratePerUnit: 0,
	batchNo: '',
	weightInKg: '',
})

function WipOpeningCreate() {
	const history = useHistory()
	const [projects, setProjects] = useState<SelectOption[]>([])
	const [project, setProject] = useState<SelectOption | null>(null)
	const [warehouses, setWarehouses] = useState<SelectOption[]>([])
	const [warehouse, setWarehouse] = useState<SelectOption | null>(null)
	const [products, setProducts] = useState<SelectOption[]>([])
	const [openingDate, setOpeningDate] = useState('')
	const [rows, setRows] = useState<OpeningRow[]>([emptyRow()])
	const [saving, setSaving] = useState(false)

	useEffect(() => {
		getProjects()
		getProducts()
	}, [])

	const getProjects = () => {
		fetch(process.env.REACT_APP_API_URL + 'lead/projects', getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				const options: SelectOption[] = (resp.data || [])
					.filter((item: any) => Number(item.id) === BLENDING_PROJECT_ID)
					.map((item: any) => ({
						label: item.name,
						value: item.id,
					}))
				setProjects(options)
				if (options.length > 0) {
					setProject(options[0])
					getWarehouses(Number(options[0].value))
				}
			})
			.catch((error) => console.log(error, 'catch the hoop'))
	}

	const getWarehouses = (idProjects: number) => {
		if (!idProjects) {
			setWarehouses([])
			setWarehouse(null)
			return
		}
		fetch(process.env.REACT_APP_API_URL + 'warehouse/' + idProjects + '/list', getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				const options: SelectOption[] = (resp.success && Array.isArray(resp.data))
					? resp.data.map((item: any) => ({
						label: item.name,
						value: item.id_warehouses,
					}))
					: []
				setWarehouses(options)
				setWarehouse(options.length === 1 ? options[0] : null)
			})
			.catch(() => {
				setWarehouses([])
				setWarehouse(null)
			})
	}

	const handleProjectChange = (option: SelectOption | null) => {
		setProject(option)
		setWarehouse(null)
		getWarehouses(option ? Number(option.value) : 0)
	}

	const getProducts = () => {
		fetch(process.env.REACT_APP_API_URL + 'wip-opening/products', getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				const options: SelectOption[] = (resp.data || []).map((item: any) => ({
					label: item.itemName,
					value: item.idItems,
					itemCode: item.itemCode,
					unitName: item.unitName,
				}))
				setProducts(options)
			})
			.catch((error) => console.log(error, 'catch the hoop'))
	}

	const handleItemChange = (option: SelectOption | null, index: number) => {
		setRows((prev) => {
			const updated = [...prev]
			updated[index] = {
				...updated[index],
				idItems: option ? Number(option.value) : '',
				itemName: option?.label || '',
				unitName: option?.unitName || '',
			}
			return updated
		})
	}

	const handleRowChange = (index: number, field: 'productionQuantity' | 'ratePerUnit' | 'batchNo' | 'weightInKg', value: string) => {
		setRows((prev) => {
			const updated = [...prev]
			updated[index] = { ...updated[index], [field]: value }
			return updated
		})
	}

	const addRow = () => {
		setRows((prev) => [...prev, emptyRow()])
	}

	const deleteRow = (index: number) => {
		setRows((prev) => prev.filter((_, i) => i !== index))
	}

	const handleSubmit = async (event: React.FormEvent) => {
		event.preventDefault()
		if (!project?.value || !warehouse?.value || !openingDate) {
			Swal.fire({ icon: 'error', title: 'Error', text: 'Project, warehouse and opening date are required.' })
			return
		}

		const payloadRows = rows
			.filter((row) => row.idItems && row.productionQuantity !== '' && Number(row.productionQuantity) > 0)
			.map((row) => ({
				idItems: Number(row.idItems),
				productionQuantity: Number(row.productionQuantity),
				ratePerUnit: row.ratePerUnit === '' ? 0 : Number(row.ratePerUnit),
				batchNo: row.batchNo,
				weightInKg: row.weightInKg === '' ? null : Number(row.weightInKg),
			}))

		if (payloadRows.length === 0) {
			Swal.fire({ icon: 'error', title: 'Error', text: 'Add at least one item with quantity.' })
			return
		}

		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: 'You want to create this WIP opening entry?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Create it!',
		})
		if (!confirm.isConfirmed) {
			return
		}

		setSaving(true)
		try {
			const response = await fetch(
				process.env.REACT_APP_API_URL + 'wip-opening',
				postRequestOptions({
					idProjects: project.value,
					idWarehouses: warehouse.value,
					productionDate: openingDate,
					rows: payloadRows,
				})
			)
			const respData = await response.json()
			if (respData.success === true) {
				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: respData.successMessage,
				}).then(() => history.push('/wip-opening'))
			} else {
				const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
				Swal.fire({
					icon: 'error',
					title: 'Error',
					html: errorsMessage || respData.errorMessage || 'Create failed.',
				})
			}
		} catch (error) {
			Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred.' })
		} finally {
			setSaving(false)
		}
	}

	return (
		<div className="card card-custom">
			<div className="card-header">
				<div className="card-title">
					<KTSVG path="/media/svg/icons/Home/Book-open.svg" className="svg-icon-1 svg-icon-primary" />
					<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
						Create WIP Opening Entry
					</span>
				</div>
			</div>
			<div className="card-body">
				<form onSubmit={handleSubmit}>
					<div className="form-group row">
						<label className="col-lg-3 col-form-label" style={{ textAlign: 'right' }}>
							Project <span className="required text-danger"></span>
						</label>
						<div className="col-lg-5">
							<Select
								value={project}
								onChange={(option) => handleProjectChange(option as SelectOption | null)}
								options={projects}
								menuPosition="fixed"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label className="col-lg-3 col-form-label" style={{ textAlign: 'right' }}>
							Warehouse <span className="required text-danger"></span>
						</label>
						<div className="col-lg-5">
							<Select
								value={warehouse}
								onChange={(option) => setWarehouse(option as SelectOption | null)}
								options={warehouses}
								placeholder="Select warehouse"
								menuPosition="fixed"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label className="col-lg-3 col-form-label" style={{ textAlign: 'right' }}>
							Opening Date <span className="required text-danger"></span>
						</label>
						<div className="col-lg-5">
							<input
								type="date"
								className="form-control form-control-sm"
								value={openingDate}
								onChange={(event) => setOpeningDate(event.target.value)}
							/>
						</div>
					</div>

					<Table size="sm" bordered hover className="mt-4">
						<thead>
							<tr>
								<th className="text-center" style={{ width: '5%' }}>SL</th>
								<th>Item <span className="text-danger">*</span></th>
								<th style={{ width: '12%' }}>Qty (Ltr) <span className="text-danger">*</span></th>
								<th style={{ width: '12%' }}>Rate</th>
								<th style={{ width: '14%' }}>Batch No</th>
								<th style={{ width: '12%' }}>Weight KG</th>
								<th style={{ width: '10%' }}></th>
							</tr>
						</thead>
						<tbody>
							{rows.map((row, index) => (
								<tr key={'opening-row-' + index}>
									<td className="text-center">{index + 1}</td>
									<td>
										<Select
											value={products.find((option) => Number(option.value) === Number(row.idItems)) || null}
											onChange={(option) => handleItemChange(option as SelectOption | null, index)}
											options={products}
											placeholder="Select item"
											menuPosition="fixed"
										/>
									</td>
									<td>
										<input
											type="number"
											step="any"
											className="form-control form-control-sm"
											value={row.productionQuantity}
											onChange={(event) => handleRowChange(index, 'productionQuantity', event.target.value)}
										/>
									</td>
									<td>
										<input
											type="number"
											step="any"
											className="form-control form-control-sm"
											value={row.ratePerUnit}
											onChange={(event) => handleRowChange(index, 'ratePerUnit', event.target.value)}
										/>
									</td>
									<td>
										<input
											type="text"
											className="form-control form-control-sm"
											value={row.batchNo}
											onChange={(event) => handleRowChange(index, 'batchNo', event.target.value)}
										/>
									</td>
									<td>
										<input
											type="number"
											step="any"
											className="form-control form-control-sm"
											value={row.weightInKg}
											onChange={(event) => handleRowChange(index, 'weightInKg', event.target.value)}
										/>
									</td>
									<td>
										{rows.length > 1 &&
											<button type="button" className="btn btn-light-primary btn-sm px-2 py-1 me-1" onClick={() => deleteRow(index)}>
												<KTSVG path="/media/svg/icons/General/Trash.svg" className="svg-icon-5 svg-icon-danger me-0" />
											</button>
										}
										{index === rows.length - 1 &&
											<button type="button" className="btn btn-success btn-sm px-2 py-1" onClick={addRow}>
												<KTSVG path="/media/svg/icons/Navigation/Plus.svg" className="svg-icon-5 me-0" /> Add
											</button>
										}
									</td>
								</tr>
							))}
						</tbody>
					</Table>

					<div className="row mt-4">
						<div className="col-12 text-center">
							<button type="submit" className="btn btn-sm btn-primary me-2" disabled={saving}>
								Submit
							</button>
							<Link to="/wip-opening" className="btn btn-sm btn-secondary">Cancel</Link>
						</div>
					</div>
				</form>
			</div>
		</div>
	)
}

export default WipOpeningCreate
